<template>
    <section id="home">
        <!-- <no-ssr> -->
        <vue-displacement-slideshow
        :images="images"
        :displacement="require('@/assets/displace.jpg')"
        :intensity="0.8"
        :speedIn="2.1"
        :speedOut="2.1"
        ease="expo.out"
        ref="slideshow"
		isInteractive="true"
        >
        </vue-displacement-slideshow>
        <!-- <no-ssr> -->
        <div class="text-and-button">
            <div class="text-wrap">
                <!-- <h1>We bring you superior IT Solutions to meet your needs</h1> -->
                <!-- <div class="divider"></div> -->
                <!-- <h2>
                    We bring you superior IT Solutions to meet your need. We
                    bring you superior IT Solutions to meet your needs
                </h2> -->
            </div>
            <button v-scroll-to="`#about`" @click="nextImage()">
				<!-- <span></span> -->
				more
            </button>
        </div>
        <!-- <end-text-and-button> -->
        <div class="custom-shape-divider-bottom-1591739578">
            <svg
                data-name="Layer 1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1200 120"
                preserveAspectRatio="none">
                <path
                    d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z"
                    class="shape-fill"></path>
            </svg>
        </div>
        <!-- <end-blue-wave> -->
    </section>
</template>

<script>
import VueDisplacementSlideshow from "vue-displacement-slideshow";

export default {
    components: {
        VueDisplacementSlideshow
    },
	data(){
		return {
			interactive: true
		}
	},

    computed: {
        images() {
            return [
                require("../assets/images/14.jpg"),
                require("../assets/images/sandton.jpg"),
                require("../assets/images/9.jpg")
            ];
        }
    },
    methods: {
        init() {
            //We loop through all our images by calling the 'next' method of our component every 2 seconds
            setInterval(() => {
                this.$refs.slideshow.next();
            }, 6000);
        },
        nextImage() {
            this.$refs.slideshow.next();
        },
        previousImage() {
            this.$refs.slideshow.previous();
        }
    },
    mounted() {

        this.init(); //initialise function   :P
    }
};
</script>
